import {useContext} from 'react'

import Logger from './Logger'
import LoggerContext from './LoggerContext'

export default function useLogger(): Logger {
  return useContext(LoggerContext)
}
